import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class ReporteService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public postReporte(infoPayload): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_REPORTE;
    //alert(url);
    return this.http.post<any>(url, infoPayload).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Formulario",
            text: "Verifique la informacion ingresada.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }
}
